import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=fadfc194&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=fadfc194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadfc194",
  null
  
)

export default component.exports